import React from "react";
import {getSyncEngineVersion} from "../../../common/helpers/syncEngine";
import DashboardV1 from "./DashboardV1";
import DashboardV2 from "./DashboardV2";

const Dashboard = () => {
    const isV2 = getSyncEngineVersion() === "v2";
    return isV2 ? <DashboardV2/> : <DashboardV1/>;
};

export default React.memo(Dashboard);
